<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <helper-accept-terms
      ref="acceptTerms" 
      @acceptTerms="createOrder"
    />
    <v-layout
      wrap
      justify-center
    >
      <v-flex
        xs12
        md4
      >
        <v-card
          class="pack-card"
          style="margin-top:85px;"
          justify-center
          text-center
        >
          <div 
            class="text-center pack-header premium"
          >
            <h2>{{ $t('packs.premium') }}</h2>
          </div>
        
          <v-flex>
            <center>
              <h3>
                {{ premiumPrice }} {{ premium.currency }}
                <span>{{ $t('packs.oneTime') }}</span>
              </h3>
            </center>
          
            <ul>
              <li>{{ $t('packs.connections') }}: <b>{{ JSON.parse(premium.config).traders }} {{ $t('packs.traders') }}</b></li>
              <li>{{ $t('packs.bots') }}: <b>{{ JSON.parse(premium.config).bots }} {{ $t('packs.lics1') }}</b></li> 
              <li>{{ $t('packs.riksManagement') }}</li>
              <li>{{ $t('packs.initAivdrop') }}</li>
            </ul>
            <v-checkbox
              v-model="premiumIbo"
              color="primary"
            > 
              <template v-slot:label>
                <small>
                  {{ JSON.parse(ibo.name)[$i18n.locale] }}: <b>{{ ibo.price }} {{ ibo.currency }}</b>
                </small>
              </template>
            </v-checkbox>
          </v-flex>
          <v-card-actions
            justify-end
          >
            <v-spacer />
            <v-btn
              class="primary"  
              :disabled="loading && selectedPack.id == premium.id"
              :loading="loading && selectedPack.id == premium.id"
              @click="validateOrder(premium)"
            >
              {{ $t('toolbar.buyButton') }}
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <v-sheet 
          style="margin-top:20px;"
          class="best-choice text-center"
          width="150"
          height="25"
          :tile="true"
          color="orange lighten-2"
        >
          <b>{{ $t('packs.bestChoice') }}</b>
        </v-sheet>
    
        <v-card
          class="pack-card"
          justify-center
          text-center
          elevation="4"
        >
          <div 
            class="text-center pack-header vip"
          >
            <h2>{{ $t('packs.vip') }}</h2>
          </div>
          <v-flex>
            <center>
              <h3>
                {{ vipPrice }} {{ vip.currency }}
                <span>{{ $t('packs.oneTime') }}</span>
              </h3>
            </center>
            <ul>
              <li>{{ $t('packs.connections') }}: <b>{{ JSON.parse(vip.config).traders == 0 ? $t('packs.unlimited'): JSON.parse(vip.config).traders }}</b></li>
              <li>{{ $t('packs.bots') }}: <b>{{ JSON.parse(vip.config).bots }} {{ $t('packs.lics2') }}</b></li> 
              <li>{{ $t('packs.academy') }}: <b>“{{ $t('packs.smartInvestor') }}"</b></li>
              <li>{{ $t('packs.riksManagement') }}</li>
              <li>{{ $t('packs.initAivdrop') }}</li>
            </ul>
            <v-checkbox
              v-model="vipIbo"
              color="primary"
            > 
              <template v-slot:label>
                <small>
                  {{ JSON.parse(ibo.name)[$i18n.locale] }}: <b>{{ ibo.price }} {{ ibo.currency }}</b>
                </small>
              </template>
            </v-checkbox>
          </v-flex>

          <v-card-actions
            justify-end
          >
            <v-spacer />
            <v-btn
              class="primary"
              :disabled="loading && selectedPack.id == vip.id"
              :loading="loading && selectedPack.id == vip.id"
              @click="validateOrder(vip)"
            >
              {{ $t('toolbar.buyButton') }}
            </v-btn> 
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-divider />
        <center style="padding: 10px 60px 10px;">
          <small>{{ $t('packs.onlyIbo') }}
            {{ JSON.parse(ibo.name)[$i18n.locale] }}: <b>{{ ibo.price }} {{ ibo.currency }}</b>
            <v-btn
              style="margin-top:-2px;"
              x-small
              text
              :disabled="loading && selectedPack.id == ibo.id"
              @click="validateOrder(ibo)"
            >{{ $t('toolbar.buyButton') }}
            </v-btn> 
          </small>
        </center>
      </v-flex>
    </v-layout>
  </v-container> 
</template>

<script>

const CREATE_ORDER_MUTATION = require('@/graphql/mutations/CreateOrder.gql');
const PRODUCTS_QUERY = require('@/graphql/queries/Products.gql');

export default {
  name: 'Packs',
  data() {
    return {
      selectedPack: null,
      premium: null,
      vip: null,
      ibo: null,
      premiumIbo: true,
      vipIbo: true,
      loading: false,
      selectedProducts: []
    }
  },
  computed: {
    premiumPrice() {
      return this.premiumIbo ? Number(this.premium.price) + Number(this.ibo.price) : this.premium.price
    },
    vipPrice() {
      return this.vipIbo ? Number(this.vip.price) + Number(this.ibo.price) : this.vip.price
    }
  },
  methods: {
    validateOrder(pack) {
      this.selectedPack = pack
      this.$refs.acceptTerms.open();
    },
    createOrder() {
      let products = []
      products.push(this.selectedPack.id)
      if(this.selectedPack.system_name.toLowerCase()  == 'premium' && this.premiumIbo 
        || this.selectedPack.system_name.toLowerCase() == 'vip' && this.vipIbo ) 
          products.push(this.ibo.id)

      this.loading = true
      this.$apollo.mutate({
          mutation: CREATE_ORDER_MUTATION,
          variables: {
            product_ids: products
          }       
      }).then(data => {       
          let invoice = data.data.createOrder.invoice
          this.$refs.acceptTerms.openGateways(invoice.id);
          this.loading = false; 
      }).catch(error => {
          this.loading = false; 
          this.errorHandler(error) 
      })
    }
  },
  apollo: {
    products: {
      query: PRODUCTS_QUERY,
      result(data) {
        if (data.loading == false) {
          this.products.forEach(item => {
            this[item.system_name.toLowerCase()] = item
          });
        }
      },
    }
  }
}
</script>
<style lang="scss" scoped>
  .best-choice {
    padding: 4px 10px;
    margin-left:2px;
    font-size:13px;
  }
  .pack-card {
    padding: 0;
    font-size:15px;
     ul {
      list-style-type: none;
      padding-left: 0px;
      margin: 10px 0 10px;
      li {
        border-bottom: 1px solid rgba(0,0,0,.12);
        padding: 10px 0 10px;
      }
    }
    .pack-header {
      width:100%;
      height:100px;
      display:table;
      h2 {
        color:#fff;
        display: table-cell;
        vertical-align: middle
      }
      &.premium {
        background-image: linear-gradient(166deg, #0e36e7, #0558ea);
      }
      &.vip {
        background-image: linear-gradient(166deg, #0a25a1, #0045be); 
      }
    }
    .v-image {
      margin: 5px 0 20px;
    }
    h4 {
      text-align: center;
      font-size: 22px!important;
      font-weight: 700!important;
      margin:0!important;
    }
    span {
      font-size: 11px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      margin-top:10px;
      max-width:250px;
    }
  }
</style>
